<script>
    import estados from '~js/estados';
    import Radio from '~componentes/Radio.vue';
    import { checkbox } from 'vue-strap';
    import converterMoeda from '~js/converter-moeda';
    import pessoaServico from '~modulos/acessos/servico';

    export default {
      components: { Radio, checkbox },
      props: {
        inscricao: {
          type: Object,
          required: true
        },
        cadastroCompleto: {
          type: Number,
        },
        doacao: {
          type: Object,
        },
        turma: {
          type: Object,
        },
        labelsLinguagemSelecionada: {},
      },
      data() {
        return {
          estados: estados,
          configuracao: this.$storage.configuracao(),

          pessoaFisica: true,
          documento: "CPF",
          mensagemValores: "",

          habilitarRecorrencia: false,
          mostrarTurma: false,
          desabilitarEndereco: false,

          selecaoCategorias: '',
        }
      },
      methods: {
        validar() {
          return this.$validator.validateAll();
        },
        setaValorDefault(valor) {
          this.inscricao.valor = this.$options.filters.formatarNumero(valor);
          this.resetarClasseBotao();

          return false;
        },
        resetarClasseBotao() {
          var els = document.querySelectorAll('.botaoValor');


          for (var i = 0; i < els.length; i++) {
            els[i].className = "btn btn-light botaoValor";
          }

          this.$validator.reset();
        },
        InsereDivValores(divValores, buttonValor, i) {
          const inscricaoDivVazia = document.querySelector("#divValor");
          var divValorInterna = document.createElement("div");
          divValorInterna.setAttribute('id', `vi${i}`);
          divValorInterna.setAttribute('class', "form-group");

          divValorInterna.appendChild(buttonValor);

          var divValor = document.createElement("div");
          divValor.setAttribute('id', `v${i}`);
          divValor.setAttribute('class', "col-lg-2");

          divValor.appendChild(divValorInterna);

          divValores.insertBefore(divValor, inscricaoDivVazia);
        },
        criaValoresDefault(valores, min, max) {
          valores.sort((a, b) => {
            return (a - b)
          });

          const divValores = document.querySelector("#valores");
          const inscricaoDivVazia = document.querySelector("#inscricaoDivVazia");

          for (var i = 0; i < valores.length; i++) {

            var hValor = document.createElement("h");
            hValor.setAttribute("style", "font-size: 18px;");
            hValor.innerText = `R$ ${this.$options.filters.formatarNumero(valores[i])}`;

            var buttonValor = document.createElement("button");
            buttonValor.setAttribute("id", `vb${i}`);
            buttonValor.setAttribute('type', 'button');
            buttonValor.setAttribute('class', "btn btn-light botaoValor");
            buttonValor.setAttribute("value", valores[i]);
            buttonValor.setAttribute("style", "height: 70px;width: 100%;");

            buttonValor.appendChild(hValor);

            var auxValor = valores[i];
            (function (auxValor, frm, btn) {
              buttonValor.addEventListener("click", () => {
                event.preventDefault();
                frm.setaValorDefault(auxValor);

                btn.setAttribute('class', "btn btn-primary botaoValor");
                const inputValor = document.getElementById("valor");
                inputValor.setAttribute('disabled', 'disabled');
              });
            }(auxValor, this, buttonValor));


            this.InsereDivValores(divValores, buttonValor, i);
          }


          if (valores.length > 0) {
            var hValor = document.createElement("h");
            hValor.setAttribute("style", "font-size: 18px;");
            hValor.innerText = this.labelsOutroValorInscricao;

            var buttonValor = document.createElement("button");
            buttonValor.setAttribute("id", `vb5`);
            buttonValor.setAttribute('class', "btn btn-primary botaoValor");
            buttonValor.setAttribute("style", "height: 70px;width: 100%;");

            buttonValor.appendChild(hValor);

            (function (frm, btn) {
              buttonValor.addEventListener("click", () => {
                event.preventDefault();

                const inputValor = document.getElementById("valor");
                inputValor.removeAttribute('disabled');

                inputValor.focus();
                frm.inscricao.valor = null;
                frm.resetarClasseBotao();
                btn.setAttribute('class', "btn btn-primary botaoValor");
              });
            }(this, buttonValor));

            this.InsereDivValores(divValores, buttonValor, 5);
            inscricaoDivVazia.setAttribute("class", `col-lg-${(8 - (valores.length * 2))}`);
          } else {
            const inputValor = document.getElementById("valor");
            inputValor.removeAttribute('disabled');
          }


          if ((min > 0) || (max > 0)) {
            if (min > 0)
              this.mensagemValores = '* ' + this.labelsValorMinimoInscricao + ' ' + `R$ ${this.$options.filters.formatarNumero(min)}`;

            if (max > 0)
              this.mensagemValores = '* ' + this.labelsValorMaximoInscricao + ' ' + `R$ ${this.$options.filters.formatarNumero(max)}`;

            if ((min > 0) && (max > 0))
              this.mensagemValores = '* ' + this.labelsValorMinimoInscricao + ' ' + `R$ ${this.$options.filters.formatarNumero(min)}` +
                ' ' + this.labelsValorMaximoInscricao + ' ' + `R$ ${this.$options.filters.formatarNumero(max)}`;
          }

        },
        montaValoresDefaultEventoCurso() {
          if (!this.turma)
            return;

          this.inscricao.questionarios = this.turma.turmaForms;

          for (var i = 0; i < this.inscricao.questionarios.length; i++) {
            if (this.inscricao.questionarios[i].tipoCampoSimNao)
              this.inscricao.questionarios[i].tipoResposta = 1

            if (this.inscricao.questionarios[i].tipoCampoResposta)
              this.inscricao.questionarios[i].tipoResposta = 2

            if (this.inscricao.questionarios[i].tipoCampoSelecao)
              this.inscricao.questionarios[i].tipoResposta = 3
          }
        },
        montaValoresDefaultDoacao() {
          if (!this.doacao)
            return;

          var valores = [];

          const valorMinimo = this.$options.filters.formatarNumero(this.doacao.valorMinimo, true);
          const valorMaximo = this.$options.filters.formatarNumero(this.doacao.valorMaximo, true);
          const valorPadrao1 = this.$options.filters.formatarNumero(this.doacao.valorPadrao1, true);
          const valorPadrao2 = this.$options.filters.formatarNumero(this.doacao.valorPadrao2, true);
          const valorPadrao3 = this.$options.filters.formatarNumero(this.doacao.valorPadrao3, true);
          const valorPadrao4 = this.$options.filters.formatarNumero(this.doacao.valorPadrao4, true);

          if (valorPadrao1 > 0)
            valores.push(valorPadrao1);

          if (valorPadrao2 > 0)
            valores.push(valorPadrao2);

          if (valorPadrao3 > 0)
            valores.push(valorPadrao3);

          if (valorPadrao4 > 0)
            valores.push(valorPadrao4);

          this.criaValoresDefault(valores, valorMinimo, valorMaximo);

          const inputValor = document.getElementById("valor");
          inputValor.removeAttribute('disabled');

          this.inscricao.questionarios = this.doacao.doacaoForms;
          this.habilitarRecorrencia = this.doacao.habilitarRecorrencia;

          for (var i = 0; i < this.inscricao.questionarios.length; i++) {
            if (this.inscricao.questionarios[i].tipoCampoSimNao)
              this.inscricao.questionarios[i].tipoResposta = 1

            if (this.inscricao.questionarios[i].tipoCampoResposta)
              this.inscricao.questionarios[i].tipoResposta = 2

            if (this.inscricao.questionarios[i].tipoCampoSelecao)
              this.inscricao.questionarios[i].tipoResposta = 3
          }
        },
        setaPessoaFisicaJuridica() {
          if (this.inscricao.documento.length > 16) {
            this.pessoaFisica = false;
            this.documento = "CNPJ";
          }
        },
        formataValorInscricao(valor) {
          return converterMoeda.paraReal(valor);
        },
        setarCategoriaValor(event) {
          this.turma.faixaValores.map(faixaValor => {
            if (faixaValor.idTurmaFaixaValores == event.target.value) {
              this.$set(this.inscricao, "valor", this.formataValorInscricao(faixaValor.valor));
              this.$set(this.inscricao, "faixaValores", faixaValor.descricao);
              this.$set(this.inscricao, "mensagemAnexoArquivos", faixaValor.textoAnexo);
              this.$set(this.inscricao, "anexoObrigatorio", faixaValor.anexoObrigatorio);
              this.$set(this.inscricao, "utilizarArquivo", faixaValor.utilizarArquivo);
              this.$set(this.inscricao, "quantidadeMinimaArquivos", faixaValor.quantidadeMinimaArquivos);
              this.$set(this.inscricao, "quantidadeMaximaArquivos", faixaValor.quantidadeMaximaArquivos);
              this.$set(this.inscricao, "idTurmaFaixaValores", faixaValor.idTurmaFaixaValores);
              this.$set(this.inscricao, "selecaoCategoria", '');
              this.$set(this, "selecaoCategorias", faixaValor.selecaoCategoria);
              this.$emit('setaQuantidadeArquivos', faixaValor.quantidadeMinimaArquivos);
              this.$validator.reset();
            }
          });
        },
        getQuestaoID(id) {
          return "questao" + id;
        },
        getQuestaoIDAs(id) {
          return "pergunta " + (id + 1);
        },
        validarCEP() {
          if (!this.configuracao.validarCEP) return true;

          var CEP = this.inscricao.cep.replace('-', '')

          if (CEP.length == 8) {
            this.$viaCep.buscarCep(CEP).then((obj) => {
              var pos = -1;

              for (var i = 0; i < this.errors.items.length; i++) {
                if (this.errors.items[i].id == "_y980gl9f3565sdasd") {
                  pos = i
                  break
                }
              }

              if (obj.erro) {
                if (pos == -1) {
                  this.errors.items.push(
                    { "id": "_y980gl9f3565sdasd", "field": "cep", "msg": "O cep informado não é válido.", "rule": "required", "scope": null }
                  )
                }
              }
              else {
                if (pos > -1) {
                  this.errors.items.splice(pos, 1)
                }
              }
            });
          }
        },
        getCEP() {
          let textoCEP = this.inscricao.cep.replace('-', '').replace('.', '')

          if (textoCEP.length == 8) {
            this.desabilitarEndereco = true;

            pessoaServico
              .cep(textoCEP)
              .then(cepObj => {
                this.inscricao.endereco = cepObj.logradouro.substring(0,100);
                this.inscricao.bairro = cepObj.bairro.substring(0, 80);
                this.inscricao.cidade = cepObj.localidade.substring(0, 40);
                this.inscricao.uf = cepObj.uf;
                this.desabilitarEndereco = false;
              })
              .catch(error => {
                this.desabilitarEndereco = false;
              });
          }
        },
        valorCategoria(faixa) {
            if (faixa.valor == 0)
              return this.labelsIsentoInscricao

            if (!faixa.valor)
                return '---'           

            return 'R$ ' + this.$options.filters.formatarNumero(faixa.valor);
        },
      },
    computed: {
        labelsOutroValorInscricao() {
          return this.labelsLinguagemSelecionada.labels.outroValorInscricao;
        },
        valorSim() {
          return this.labelsLinguagemSelecionada.labels.simInscricao
        },
        valorNao() {
          return this.labelsLinguagemSelecionada.labels.naoInscricao
        },
        obrigatorioMensagem() {
          return this.labelsLinguagemSelecionada.labels.obrigatorioInscricao
        },
        labelsValorMaximoInscricao() {
          return this.labelsLinguagemSelecionada.labels.valorMaximoInscricao;
        },
        labelsValorMinimoInscricao() {
          return this.labelsLinguagemSelecionada.labels.valorMinimoInscricao;
        },
        labelsIsentoInscricao() {
          return this.labelsLinguagemSelecionada.labels.isentoInscricao;
        },
        validarDataNascimento() {
          return this.configuracao.permitirCadPFSemDataNascimento ? 'date_format:DD/MM/YYYY' : 'required|date_format:DD/MM/YYYY'
        },
        labelsMinimoMaximoDoacao() {
          if (!this.doacao)
            return;

          var valores = [];

          const min = this.$options.filters.formatarNumero(this.doacao.valorMinimo, true);
          const max = this.$options.filters.formatarNumero(this.doacao.valorMaximo, true);

          if ((min > 0) || (max > 0)) {
            if (min > 0)
              this.mensagemValores = '* ' + this.labelsValorMinimoInscricao + ' ' + `R$ ${this.$options.filters.formatarNumero(min)}`;

            if (max > 0)
              this.mensagemValores = '* ' + this.labelsValorMaximoInscricao + ' ' + `R$ ${this.$options.filters.formatarNumero(max)}`;

            if ((min > 0) && (max > 0))
              this.mensagemValores = '* ' + this.labelsValorMinimoInscricao + ' ' + `R$ ${this.$options.filters.formatarNumero(min)}` +
                ' ' + this.labelsValorMaximoInscricao + ' ' + `R$ ${this.$options.filters.formatarNumero(max)}`;
          }

          return this.mensagemValores;
        }
      },
      mounted() {
        this.montaValoresDefaultDoacao();
        this.montaValoresDefaultEventoCurso();
        this.setaPessoaFisicaJuridica();

        if (this.turma != null) {
          this.mostrarTurma = true;
        }
      },
      updated(){
        const _this = this;

        this.$watch('inscricao.cep', function () {
            _this.getCEP();
        })
      },
      watch: {

      },
    }
</script>


<style scoped>
    .radioLeft {
        margin-left: 9px;
    }
</style>

<template>
  <div>
    <div class="row">
      <div class="col-sm-8">
        <div class="form-group required" :class="{'has-error': errors.has('nome')}">
          <label class="control-label" for="nome">{{ this.labelsLinguagemSelecionada.labels.nomeInscricao }}</label>

          <input type="text"
                 class="form-control"
                 id="nome"
                 v-model="inscricao.nome"
                 data-vv-name="nome"
                 data-vv-as="nome"
                 v-validate="documento == 'CPF' ? `required|nomecompleto` : 'required'"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('nome')">{{ this.labelsLinguagemSelecionada.labels.nomeInscricao }} {{ this.labelsLinguagemSelecionada.labels.obrigatorioInscricao }}</p>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group required">
          <label class="control-label" for="documento">{{ documento }}</label>

          <input type="text"
                 class="form-control"
                 id="documento"
                 v-model="inscricao.documento"
                 disabled>
        </div>
      </div>
    </div>

    <div class="row" v-if="cadastroCompleto == 1">
      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('cep')}">
          <label class="control-label" for="cep">{{ this.labelsLinguagemSelecionada.labels.cepBuscaInscricao }}</label>

          <input type="text"
                 class="form-control"
                 id="cep"
                 v-model="inscricao.cep"
                 data-vv-as="cep"
                 data-vv-name="cep"
                 v-mascara="'cep'"
                 :disabled="desabilitarEndereco"
                 @change="validarCEP"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('cep')">{{ this.labelsLinguagemSelecionada.labels.cepBuscaInscricao }} {{ this.labelsLinguagemSelecionada.labels.obrigatorioInscricao }}</p>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group required" :class="{'has-error': errors.has('endereco')}">
          <label class="control-label" for="endereco">{{ this.labelsLinguagemSelecionada.labels.enderecoInscricao }}</label>

          <input id="endereco"
                 class="form-control"
                 type="text"
                 v-model="inscricao.endereco"
                 data-vv-name="endereco"
                 data-vv-as="endereço"
                 v-validate="'required'"
                 :disabled="desabilitarEndereco"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('endereco')">{{ this.labelsLinguagemSelecionada.labels.enderecoInscricao }} {{ this.labelsLinguagemSelecionada.labels.obrigatorioInscricao }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('numero')}">
          <label class="control-label" for="numero">{{ this.labelsLinguagemSelecionada.labels.numeroInscricao }}</label>

          <input id="numero"
                 class="form-control"
                 type="text"
                 v-model="inscricao.numero"
                 data-vv-name="numero"
                 data-vv-as="número"
                 v-validate="'required'"
                 maxlength="10">

          <p class="text-danger" v-show="errors.has('numero')">{{ this.labelsLinguagemSelecionada.labels.numeroInscricao }} {{ this.labelsLinguagemSelecionada.labels.obrigatorioInscricao }}</p>
        </div>
      </div>


    </div>

    <div class="row" v-if="cadastroCompleto == 1">
      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="complemento">{{ this.labelsLinguagemSelecionada.labels.complementoInscricao }}</label>

          <input id="complemento"
                 class="form-control"
                 type="text"
                 v-model="inscricao.complemento"
                 maxlength="80">
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group required" :class="{'has-error': errors.has('bairro')}">
          <label class="control-label" for="bairro">{{ this.labelsLinguagemSelecionada.labels.bairroInscricao }}</label>

          <input type="text"
                 class="form-control"
                 id="bairro"
                 v-model="inscricao.bairro"
                 data-vv-as="bairro"
                 data-vv-name="bairro"
                 v-validate="'required'"
                 :disabled="desabilitarEndereco"
                 maxlength="80">

          <p class="text-danger" v-show="errors.has('bairro')">{{ this.labelsLinguagemSelecionada.labels.bairroInscricao }} {{ this.labelsLinguagemSelecionada.labels.obrigatorioInscricao }}</p>
        </div>
      </div>

      <div class="col-sm-5">
        <div class="form-group required" :class="{'has-error': errors.has('cidade')}">
          <label class="control-label" for="cidade">{{ this.labelsLinguagemSelecionada.labels.cidadeInscricao }}</label>

          <input type="text"
                 class="form-control"
                 id="cidade"
                 v-model="inscricao.cidade"
                 data-vv-as="cidade"
                 data-vv-name="cidade"
                 v-validate="'required'"
                 :disabled="desabilitarEndereco"
                 maxlength="40">

          <p class="text-danger" v-show="errors.has('cidade')">{{ this.labelsLinguagemSelecionada.labels.cidadeInscricao }} {{ this.labelsLinguagemSelecionada.labels.obrigatorioInscricao }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="cadastroCompleto == 1">
      <div :class="[pessoaFisica ? 'col-lg-3' : 'col-lg-4']">
        <div class="form-group required" :class="{'has-error': errors.has('uf')}">
          <label class="control-label" for="uf">{{ this.labelsLinguagemSelecionada.labels.estadoInscricao }}</label>

          <select id="uf"
                  class="form-control"
                  v-model="inscricao.uf"
                  data-vv-as="estado"
                  data-vv-name="uf"
                  :disabled="desabilitarEndereco"
                  v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="estado.sigla" v-for="estado in estados">{{ estado.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('uf')">{{ this.labelsLinguagemSelecionada.labels.estadoInscricao }} {{ this.labelsLinguagemSelecionada.labels.obrigatorioInscricao }}</p>
        </div>
      </div>

      <div :class="[pessoaFisica ? 'col-lg-3' : 'col-lg-4']">
        <div class="form-group required" :class="{'has-error': errors.has('telefone')}">
          <label class="control-label" for="telefone">{{ this.labelsLinguagemSelecionada.labels.telefoneInscricao }}</label>

          <input type="text"
                 class="form-control"
                 id="telefone"
                 v-mascara="'telefone'"
                 v-model="inscricao.telefone"
                 data-vv-as="telefone"
                 data-vv-name="telefone"
                 maxlength="20"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('telefone')">{{ this.labelsLinguagemSelecionada.labels.telefoneInscricao }} {{ this.labelsLinguagemSelecionada.labels.obrigatorioInscricao }}</p>
        </div>
      </div>

      <div :class="[pessoaFisica ? 'col-lg-3' : 'col-lg-4']">
        <div class="form-group" :class="{'has-error': errors.has('celular')}">
          <label class="control-label" for="telefone">{{ this.labelsLinguagemSelecionada.labels.celularInscricao }}</label>

          <input type="text"
                 class="form-control"
                 id="celular"
                 v-mascara="'telefone'"
                 v-model="inscricao.celular"
                 data-vv-as="celular"
                 data-vv-name="celular"
                 maxlength="15">

          <p class="text-danger" v-show="errors.has('celular')">{{ errors.first('celular') }}</p>
        </div>
      </div>

      <div class="col-lg-3" v-if="pessoaFisica">
        <div class="form-group required" :class="{'has-error': errors.has('dataNascimento')}">
          <label class="control-label" for="nascimento">{{ this.labelsLinguagemSelecionada.labels.dataNascimentoInscricao }}</label>

          <input id="nascimento"
                 class="form-control"
                 type="text"
                 v-model="inscricao.dataNascimento"
                 v-mascara="'data'"
                 placeholder="    /    /"
                 data-vv-name="dataNascimento"
                 data-vv-as="data de nascimento"
                 v-validate="validarDataNascimento">

          <p class="text-danger" v-show="errors.has('dataNascimento')">{{ this.labelsLinguagemSelecionada.labels.dataNascimentoInscricao }} {{ this.labelsLinguagemSelecionada.labels.obrigatorioInscricao }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('contato')}">
          <label class="control-label" for="email">{{ this.labelsLinguagemSelecionada.labels.emailInscricao }}</label>

          <input type="text"
                 class="form-control"
                 id="email"
                 v-model="inscricao.email"
                 data-vv-as="e-mail"
                 data-vv-name="contato"
                 v-validate="'required'"
                 maxlength="300"
                 v-caracteres-email>

          <p class="text-danger" v-show="errors.has('contato')">{{ this.labelsLinguagemSelecionada.labels.emailInscricao }} {{ this.labelsLinguagemSelecionada.labels.obrigatorioInscricao }}</p>
        </div>
      </div>
    </div>

    <div class="hr-line-dashed margin-top-20" v-if="habilitarRecorrencia"></div>

    <div class="row" v-if="habilitarRecorrencia">
      <dl class="col-xs-12">
        <dd>
          {{ doacao.mensagemRecorrencia }}
        </dd>
      </dl>
    </div>

    <div class="row" v-if="habilitarRecorrencia">
      <div class="col-xs-12">
        <div class="checkbox">
          <checkbox v-model="inscricao.habilitarRecorrencia" value="1" type="success">
            {{ this.labelsLinguagemSelecionada.labels.habilitarRecorrencia }}
          </checkbox>
        </div>
      </div>
    </div>

    <div class="hr-line-dashed margin-top-20" v-if="inscricao.questionarios.length > 0"></div>

    <h3 class="m-t-none m-b" v-if="inscricao.questionarios.length > 0">{{ this.labelsLinguagemSelecionada.labels.questionarioInscricao }}:</h3>

    <div v-for="(questionario, index) in inscricao.questionarios">

      <div class="row">
        <div class="col-sm-10">
          <div class="form-group">
            <label class="control-label" for="pergunta" style="padding-top: 11px;">{{index + 1}} - {{questionario.pergunta}}</label>
            <label style="color:red; padding-right:3px; font-size:17px;" v-if="questionario.tipoCampoResposta | questionario.tipoCampoSelecao">{{questionario.obrigatorio ? '*' : ''}}</label>
          </div>
        </div>

        <div class="col-sm-2" v-if="questionario.tipoCampoSimNao">
          <div class="form-group" :class="{'required': questionario.obrigatorio }">
            <label style="color:red; padding-right:3px; font-size:17px;">{{questionario.obrigatorio ? '*' : ''}}</label>
            <radio v-model="questionario.selecionado"
                   selected-value="true"
                   type="success"
                   :inline="true"
                   class="margin-right-10"
                   :class="[questionario.obrigatorio ? '' : 'radioLeft']">
              {{valorSim}}
            </radio>
            <radio v-model="questionario.selecionado"
                   selected-value="false"
                   data-vv-name="atividadesIniciadas"
                   type="success"
                   :inline="true">
              {{valorNao}}
            </radio>
          </div>
        </div>
      </div>

      <div class="row" v-if="questionario.tipoCampoResposta">
        <div class="col-sm-12">
          <div class="form-group" :class="{'required': questionario.obrigatorio, 'has-error': errors.has(getQuestaoID(index)) }">
            <input type="text"
                   class="form-control"
                   :id="getQuestaoID(index)"
                   v-model="questionario.campoResposta"
                   :data-vv-as="getQuestaoIDAs(index)"
                   :data-vv-name="getQuestaoID(index)"
                   v-validate="questionario.obrigatorio ? 'required' : ''">

            <p class="text-danger" v-show="errors.has(getQuestaoID(index))">{{ obrigatorioMensagem }}</p>
          </div>
        </div>
      </div>

      <div class="row" v-if="questionario.tipoCampoSelecao">
        <div class="col-sm-12">
          <div class="form-group" :class="{'required': questionario.obrigatorio, 'has-error': errors.has(getQuestaoID(index)) }">
            <select :id="getQuestaoID(index)"
                    class="form-control"
                    v-model="questionario.campoResposta"
                    :data-vv-as="getQuestaoIDAs(index)"
                    :data-vv-name="getQuestaoID(index)"
                    v-validate="questionario.obrigatorio ? 'required' : ''">
              <option value="">Selecione...</option>
              <option :value="tipoCampoSelecaoItens" v-for="(tipoCampoSelecaoItens, i) in questionario.tipoCampoSelecaoItens.split('\n')">{{ tipoCampoSelecaoItens }}</option>
            </select>

            <p class="text-danger" v-show="errors.has(getQuestaoID(index))">{{ obrigatorioMensagem }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="hr-line-dashed margin-top-20"></div>

    <div class="row" id="valores">
      <div class="col-sm-10" id="inscricaoDivVazia">
        <div class="form-group required" :class="{'has-error': errors.has('categoria')}" v-if='mostrarTurma'>
          <label class="control-label" for="categoria">{{ this.labelsLinguagemSelecionada.labels.categoriasInscricao }}</label>

          <select id="categoria"
                  class="form-control"
                  v-model="inscricao.idTurmaFaixaValores"
                  data-vv-as="categoria de inscrição"
                  data-vv-name="categoria"
                  @change="setarCategoriaValor($event)"
                  v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="faixaValor.idTurmaFaixaValores" v-for="faixaValor in turma.faixaValores">{{ faixaValor.descricao }} - {{ valorCategoria(faixaValor) }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('categoria')">{{ this.labelsLinguagemSelecionada.labels.categoriasInscricao }} {{ this.labelsLinguagemSelecionada.labels.obrigatorioInscricao }}</p>
        </div>
      </div>

      <div class="col-sm-2" id="divValor">
        <div class="form-group required" :class="{'has-error': errors.has('valor')}">
          <label class="control-label" for="valor">{{ this.labelsLinguagemSelecionada.labels.valorCategoriaInscricao }}</label>

          <input type="text"
                 class="form-control"
                 id="valor"
                 v-model="inscricao.valor"
                 data-vv-name="valor"
                 data-vv-as="valor"
                 v-mascara="'moeda'"
                 v-validate="'required|not_zero'"
                 disabled>

          <p class="text-danger" v-show="errors.has('valor')">{{ this.labelsLinguagemSelecionada.labels.valorCategoriaInscricao }} {{ this.labelsLinguagemSelecionada.labels.obrigatorioInscricao }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if='selecaoCategorias'>
      <div class="col-sm-12">
        <div class="form-group" :class="{'required': true, 'has-error': errors.has('CampoSelecaoCategorias') }">
          <select :id="CampoSelecaoCategorias"
                  class="form-control"
                  v-model="inscricao.selecaoCategoria"
                  data-vv-as="acima"
                  data-vv-name="CampoSelecaoCategorias"
                  v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="tipoCampoSelecaoItens" v-for="(tipoCampoSelecaoItens, i) in selecaoCategorias.split('\n')">{{ tipoCampoSelecaoItens }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('CampoSelecaoCategorias')">{{ obrigatorioMensagem }}</p>
        </div>
      </div>
    </div>

    <div class="row" id="valoresMinMax">
      <div class="col-lg-12" style='text-align:right'>
        {{ labelsMinimoMaximoDoacao }}
      </div>
    </div>

    <div class="hr-line-dashed margin-top-20"></div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/acessos/componentes/compartilhado/AcessosInscricaoFormPFPJ.vue